import { messages as apiHooksCommonUseFileUpload } from '@/i18n/translations/pt-BR/api/hooks/common/useFileUpload';
import { messages as apiHooksPublicUseActivateAccount } from '@/i18n/translations/pt-BR/api/hooks/public/useActivateAccount';
import { messages as apiHooksPublicUseResendAccountActivation } from '@/i18n/translations/pt-BR/api/hooks/public/useResendAccountActivation';
import { messages as apiHooksPublicUseResetPassword } from '@/i18n/translations/pt-BR/api/hooks/public/useResetPassword';
import { messages as apiHooksPublicUseSignin } from '@/i18n/translations/pt-BR/api/hooks/public/useSignin';
import { messages as apiRoutesCommonFilesApi } from '@/i18n/translations/pt-BR/api/routes/common/files.api';
import { messages as componentsAvatarUploaderImageCropModal } from '@/i18n/translations/pt-BR/components/AvatarUploader/ImageCropModal';
import { messages as componentsAvatarUploaderIndex } from '@/i18n/translations/pt-BR/components/AvatarUploader/index';
import { messages as componentsFormsAddressFields } from '@/i18n/translations/pt-BR/components/forms/AddressFields';
import { messages as componentsErrorBoundary } from '@/i18n/translations/pt-BR/components/ErrorBoundary';
import { messages as componentsLoadErrorState } from '@/i18n/translations/pt-BR/components/LoadErrorState';
import { messages as componentsModal } from '@/i18n/translations/pt-BR/components/Modal';
import { messages as componentsTemplatePartnerTemplate } from '@/i18n/translations/pt-BR/components/template/PartnerTemplate';
import { messages as domainAccountStatusAccountStatus } from '@/i18n/translations/pt-BR/domain/account-status/AccountStatus';
import { messages as domainAccountStatusComponentsStatusPending } from '@/i18n/translations/pt-BR/domain/account-status/components/StatusPending';
import { messages as domainAccountStatusComponentsStatusRejected } from '@/i18n/translations/pt-BR/domain/account-status/components/StatusRejected';
import { messages as domainAccountStatusComponentsStatusSuspended } from '@/i18n/translations/pt-BR/domain/account-status/components/StatusSuspended';
import { messages as domainAccountStatusUtils } from '@/i18n/translations/pt-BR/domain/account-status/utils';
import { messages as domainEventsEventDetail } from '@/i18n/translations/pt-BR/domain/events/EventDetail';
import { messages as domainEventsComponentsEventDetailHeader } from '@/i18n/translations/pt-BR/domain/events/components/EventDetailHeader';
import { messages as domainEventsComponentsEventDetailIndicators } from '@/i18n/translations/pt-BR/domain/events/components/EventDetailIndicators';
import { messages as domainEventsComponentsEventDetailInfo } from '@/i18n/translations/pt-BR/domain/events/components/EventDetailInfo';
import { messages as domainEventsComponentsEventReviewHistory } from '@/i18n/translations/pt-BR/domain/events/components/EventReviewHistory';
import { messages as domainEventsComponentsEventStatusAlert } from '@/i18n/translations/pt-BR/domain/events/components/EventStatusAlert';
import { messages as domainEventsComponentsEventSubmitChecklist } from '@/i18n/translations/pt-BR/domain/events/components/EventSubmitChecklist';
import { messages as domainEventsEventForm } from '@/i18n/translations/pt-BR/domain/events/EventForm';
import { messages as domainEventsComponentsEventBannerField } from '@/i18n/translations/pt-BR/domain/events/components/EventBannerField';
import { messages as domainEventsComponentsEventEditor } from '@/i18n/translations/pt-BR/domain/events/components/EventEditor';
import { messages as domainEventsComponentsEventWhenFields } from '@/i18n/translations/pt-BR/domain/events/components/EventWhenFields';
import { messages as domainEventsSchemas } from '@/i18n/translations/pt-BR/domain/events/schemas';
import { messages as domainEventsEventsList } from '@/i18n/translations/pt-BR/domain/events/EventsList';
import { messages as domainEventsComponentsEventsEmptyState } from '@/i18n/translations/pt-BR/domain/events/components/EventsEmptyState';
import { messages as domainEventsComponentsEventsTable } from '@/i18n/translations/pt-BR/domain/events/components/EventsTable';
import { messages as domainEventsUtils } from '@/i18n/translations/pt-BR/domain/events/utils';
import { messages as domainAuthActivateAccount } from '@/i18n/translations/pt-BR/domain/auth/ActivateAccount';
import { messages as domainAuthResetPassword } from '@/i18n/translations/pt-BR/domain/auth/ResetPassword';
import { messages as domainAuthSignUp } from '@/i18n/translations/pt-BR/domain/auth/SignUp';
import { messages as domainAuthComponentsAuthAccessCard } from '@/i18n/translations/pt-BR/domain/auth/components/AuthAccessCard';
import { messages as domainAuthComponentsAuthCardContainer } from '@/i18n/translations/pt-BR/domain/auth/components/AuthCardContainer';
import { messages as domainAuthComponentsAuthPageLayout } from '@/i18n/translations/pt-BR/domain/auth/components/AuthPageLayout';
import { messages as domainAuthComponentsAuthPartnerHighlights } from '@/i18n/translations/pt-BR/domain/auth/components/AuthPartnerHighlights';
import { messages as domainAuthComponentsForgotPassword } from '@/i18n/translations/pt-BR/domain/auth/components/ForgotPassword';
import { messages as domainAuthComponentsSignInCard } from '@/i18n/translations/pt-BR/domain/auth/components/SignInCard';
import { messages as domainAuthComponentsSignUpSuccessModal } from '@/i18n/translations/pt-BR/domain/auth/components/SignUpSuccessModal';
import { messages as domainAuthSchemas } from '@/i18n/translations/pt-BR/domain/auth/schemas';
import { messages as domainOnboardingOnboarding } from '@/i18n/translations/pt-BR/domain/onboarding/Onboarding';
import { messages as domainOnboardingComponentsContactStep } from '@/i18n/translations/pt-BR/domain/onboarding/components/ContactStep';
import { messages as domainOnboardingComponentsOnboardingForm } from '@/i18n/translations/pt-BR/domain/onboarding/components/OnboardingForm';
import { messages as domainOnboardingComponentsOrganizationStep } from '@/i18n/translations/pt-BR/domain/onboarding/components/OrganizationStep';
import { messages as domainOnboardingComponentsReviewStep } from '@/i18n/translations/pt-BR/domain/onboarding/components/ReviewStep';
import { messages as domainOnboardingSchemas } from '@/i18n/translations/pt-BR/domain/onboarding/schemas';
import { messages as domainOnboardingUtils } from '@/i18n/translations/pt-BR/domain/onboarding/utils';
import { messages as hooksUsePostalCodeLookup } from '@/i18n/translations/pt-BR/hooks/usePostalCodeLookup';
import { messages as utilsError } from '@/i18n/translations/pt-BR/utils/error';
import { messages as utilsErrors } from '@/i18n/translations/pt-BR/utils/errors';
import { messages as utilsImage } from '@/i18n/translations/pt-BR/utils/image';
import { messages as utilsSchemas } from '@/i18n/translations/pt-BR/utils/schemas';
import { messages as componentsTemplatePartnerNav } from '@/i18n/translations/pt-BR/components/template/PartnerNav';
import { messages as domainOffersOffersList } from '@/i18n/translations/pt-BR/domain/offers/OffersList';
import { messages as domainOffersOfferForm } from '@/i18n/translations/pt-BR/domain/offers/OfferForm';
import { messages as domainOffersOfferDetail } from '@/i18n/translations/pt-BR/domain/offers/OfferDetail';
import { messages as domainOffersSchemas } from '@/i18n/translations/pt-BR/domain/offers/schemas';
import { messages as domainOffersUtils } from '@/i18n/translations/pt-BR/domain/offers/utils';
import { messages as domainOffersComponentsOfferActionCard } from '@/i18n/translations/pt-BR/domain/offers/components/OfferActionCard';
import { messages as domainOffersComponentsOfferActionsFields } from '@/i18n/translations/pt-BR/domain/offers/components/OfferActionsFields';
import { messages as domainOffersComponentsOfferBenefitFields } from '@/i18n/translations/pt-BR/domain/offers/components/OfferBenefitFields';
import { messages as domainOffersComponentsOfferLocationsFields } from '@/i18n/translations/pt-BR/domain/offers/components/OfferLocationsFields';
import { messages as domainOffersComponentsOfferDetailInfo } from '@/i18n/translations/pt-BR/domain/offers/components/OfferDetailInfo';
import { messages as domainOffersComponentsOfferEditor } from '@/i18n/translations/pt-BR/domain/offers/components/OfferEditor';
import { messages as domainOffersComponentsOfferImageField } from '@/i18n/translations/pt-BR/domain/offers/components/OfferImageField';
import { messages as domainOffersComponentsOfferPreviewCard } from '@/i18n/translations/pt-BR/domain/offers/components/OfferPreviewCard';
import { messages as domainOffersComponentsOfferStatusAlert } from '@/i18n/translations/pt-BR/domain/offers/components/OfferStatusAlert';
import { messages as domainOffersComponentsOffersEmptyState } from '@/i18n/translations/pt-BR/domain/offers/components/OffersEmptyState';
import { messages as domainOffersComponentsOffersTable } from '@/i18n/translations/pt-BR/domain/offers/components/OffersTable';
import { messages as domainAcquisitionAcquisitionLinks } from '@/i18n/translations/pt-BR/domain/acquisition/AcquisitionLinks';
import { messages as domainAcquisitionUtils } from '@/i18n/translations/pt-BR/domain/acquisition/utils';
import { messages as domainAcquisitionComponentsAcquisitionDailyChart } from '@/i18n/translations/pt-BR/domain/acquisition/components/AcquisitionDailyChart';
import { messages as domainAcquisitionComponentsAcquisitionEmptyState } from '@/i18n/translations/pt-BR/domain/acquisition/components/AcquisitionEmptyState';
import { messages as domainAcquisitionComponentsAcquisitionIndicatorsStrip } from '@/i18n/translations/pt-BR/domain/acquisition/components/AcquisitionIndicatorsStrip';
import { messages as domainAcquisitionComponentsAcquisitionLinkCard } from '@/i18n/translations/pt-BR/domain/acquisition/components/AcquisitionLinkCard';
import { messages as domainAcquisitionComponentsCommissionSummaryCard } from '@/i18n/translations/pt-BR/domain/acquisition/components/CommissionSummaryCard';
import { messages as domainResultsResults } from '@/i18n/translations/pt-BR/domain/results/Results';
import { messages as domainResultsUtils } from '@/i18n/translations/pt-BR/domain/results/utils';
import { messages as domainResultsComponentsCampaignLeadsSection } from '@/i18n/translations/pt-BR/domain/results/components/CampaignLeadsSection';
import { messages as domainResultsComponentsCampaignPicker } from '@/i18n/translations/pt-BR/domain/results/components/CampaignPicker';
import { messages as domainResultsComponentsCampaignSummary } from '@/i18n/translations/pt-BR/domain/results/components/CampaignSummary';
import { messages as domainResultsComponentsClicksByDayChart } from '@/i18n/translations/pt-BR/domain/results/components/ClicksByDayChart';
import { messages as domainResultsComponentsReportActionsTable } from '@/i18n/translations/pt-BR/domain/results/components/ReportActionsTable';
import { messages as domainResultsComponentsReportIndicators } from '@/i18n/translations/pt-BR/domain/results/components/ReportIndicators';
import { messages as domainResultsComponentsReportSlicesTable } from '@/i18n/translations/pt-BR/domain/results/components/ReportSlicesTable';
import { messages as domainResultsComponentsResultsEmptyState } from '@/i18n/translations/pt-BR/domain/results/components/ResultsEmptyState';
import { messages as domainIntegrationIntegration } from '@/i18n/translations/pt-BR/domain/integration/Integration';
import { messages as domainIntegrationComponentsIntegrationActivityLog } from '@/i18n/translations/pt-BR/domain/integration/components/IntegrationActivityLog';
import { messages as domainIntegrationComponentsIntegrationDocs } from '@/i18n/translations/pt-BR/domain/integration/components/IntegrationDocs';
import { messages as domainIntegrationComponentsIntegrationIndicators } from '@/i18n/translations/pt-BR/domain/integration/components/IntegrationIndicators';
import { messages as domainIntegrationComponentsIntegrationKeyCard } from '@/i18n/translations/pt-BR/domain/integration/components/IntegrationKeyCard';
import { messages as domainAccountAccount } from '@/i18n/translations/pt-BR/domain/account/Account';
import { messages as domainAccountAccountEdit } from '@/i18n/translations/pt-BR/domain/account/AccountEdit';
import { messages as domainAccountSchemas } from '@/i18n/translations/pt-BR/domain/account/schemas';
import { messages as domainAccountUtils } from '@/i18n/translations/pt-BR/domain/account/utils';
import { messages as domainAccountComponentsAccountMembersCard } from '@/i18n/translations/pt-BR/domain/account/components/AccountMembersCard';
import { messages as domainAccountComponentsAccountProfileCard } from '@/i18n/translations/pt-BR/domain/account/components/AccountProfileCard';
import { messages as domainAccountComponentsAccountStatusCard } from '@/i18n/translations/pt-BR/domain/account/components/AccountStatusCard';
import { messages as domainAccountComponentsInviteMemberModal } from '@/i18n/translations/pt-BR/domain/account/components/InviteMemberModal';
import { messages as domainInvitePartnerInvite } from '@/i18n/translations/pt-BR/domain/invite/PartnerInvite';
import { messages as domainInviteComponentsInviteSummary } from '@/i18n/translations/pt-BR/domain/invite/components/InviteSummary';
/**
 * Reference catalogue (the only locale shipped). Each entry mirrors a source file below `src`;
 * register a new catalogue here when its source file starts translating.
 */
export const ptBRTranslations = {
  api: {
    hooks: {
      common: {
        useFileUpload: apiHooksCommonUseFileUpload,
      },
      public: {
        useActivateAccount: apiHooksPublicUseActivateAccount,
        useResendAccountActivation: apiHooksPublicUseResendAccountActivation,
        useResetPassword: apiHooksPublicUseResetPassword,
        useSignin: apiHooksPublicUseSignin,
      },
    },
    routes: {
      common: {
        'files.api': apiRoutesCommonFilesApi,
      },
    },
  },
  components: {
    AvatarUploader: {
      ImageCropModal: componentsAvatarUploaderImageCropModal,
      index: componentsAvatarUploaderIndex,
    },
    ErrorBoundary: componentsErrorBoundary,
    forms: {
      AddressFields: componentsFormsAddressFields,
    },
    LoadErrorState: componentsLoadErrorState,
    Modal: componentsModal,
    template: {
      PartnerNav: componentsTemplatePartnerNav,
      PartnerTemplate: componentsTemplatePartnerTemplate,
    },
  },
  domain: {
    acquisition: {
      AcquisitionLinks: domainAcquisitionAcquisitionLinks,
      components: {
        AcquisitionDailyChart: domainAcquisitionComponentsAcquisitionDailyChart,
        AcquisitionEmptyState: domainAcquisitionComponentsAcquisitionEmptyState,
        AcquisitionIndicatorsStrip: domainAcquisitionComponentsAcquisitionIndicatorsStrip,
        AcquisitionLinkCard: domainAcquisitionComponentsAcquisitionLinkCard,
        CommissionSummaryCard: domainAcquisitionComponentsCommissionSummaryCard,
      },
      utils: domainAcquisitionUtils,
    },
    account: {
      Account: domainAccountAccount,
      AccountEdit: domainAccountAccountEdit,
      components: {
        AccountMembersCard: domainAccountComponentsAccountMembersCard,
        AccountProfileCard: domainAccountComponentsAccountProfileCard,
        AccountStatusCard: domainAccountComponentsAccountStatusCard,
        InviteMemberModal: domainAccountComponentsInviteMemberModal,
      },
      schemas: domainAccountSchemas,
      utils: domainAccountUtils,
    },
    'account-status': {
      AccountStatus: domainAccountStatusAccountStatus,
      components: {
        StatusPending: domainAccountStatusComponentsStatusPending,
        StatusRejected: domainAccountStatusComponentsStatusRejected,
        StatusSuspended: domainAccountStatusComponentsStatusSuspended,
      },
      utils: domainAccountStatusUtils,
    },
    auth: {
      ActivateAccount: domainAuthActivateAccount,
      ResetPassword: domainAuthResetPassword,
      SignUp: domainAuthSignUp,
      components: {
        AuthAccessCard: domainAuthComponentsAuthAccessCard,
        AuthCardContainer: domainAuthComponentsAuthCardContainer,
        AuthPageLayout: domainAuthComponentsAuthPageLayout,
        AuthPartnerHighlights: domainAuthComponentsAuthPartnerHighlights,
        ForgotPassword: domainAuthComponentsForgotPassword,
        SignInCard: domainAuthComponentsSignInCard,
        SignUpSuccessModal: domainAuthComponentsSignUpSuccessModal,
      },
      schemas: domainAuthSchemas,
    },
    events: {
      EventDetail: domainEventsEventDetail,
      EventForm: domainEventsEventForm,
      EventsList: domainEventsEventsList,
      components: {
        EventBannerField: domainEventsComponentsEventBannerField,
        EventDetailHeader: domainEventsComponentsEventDetailHeader,
        EventDetailIndicators: domainEventsComponentsEventDetailIndicators,
        EventDetailInfo: domainEventsComponentsEventDetailInfo,
        EventReviewHistory: domainEventsComponentsEventReviewHistory,
        EventStatusAlert: domainEventsComponentsEventStatusAlert,
        EventSubmitChecklist: domainEventsComponentsEventSubmitChecklist,
        EventEditor: domainEventsComponentsEventEditor,
        EventWhenFields: domainEventsComponentsEventWhenFields,
        EventsEmptyState: domainEventsComponentsEventsEmptyState,
        EventsTable: domainEventsComponentsEventsTable,
      },
      schemas: domainEventsSchemas,
      utils: domainEventsUtils,
    },
    invite: {
      PartnerInvite: domainInvitePartnerInvite,
      components: {
        InviteSummary: domainInviteComponentsInviteSummary,
      },
    },
    integration: {
      Integration: domainIntegrationIntegration,
      components: {
        IntegrationActivityLog: domainIntegrationComponentsIntegrationActivityLog,
        IntegrationDocs: domainIntegrationComponentsIntegrationDocs,
        IntegrationIndicators: domainIntegrationComponentsIntegrationIndicators,
        IntegrationKeyCard: domainIntegrationComponentsIntegrationKeyCard,
      },
    },
    offers: {
      OfferDetail: domainOffersOfferDetail,
      OfferForm: domainOffersOfferForm,
      OffersList: domainOffersOffersList,
      components: {
        OfferActionCard: domainOffersComponentsOfferActionCard,
        OfferActionsFields: domainOffersComponentsOfferActionsFields,
        OfferBenefitFields: domainOffersComponentsOfferBenefitFields,
        OfferDetailInfo: domainOffersComponentsOfferDetailInfo,
        OfferEditor: domainOffersComponentsOfferEditor,
        OfferImageField: domainOffersComponentsOfferImageField,
        OfferLocationsFields: domainOffersComponentsOfferLocationsFields,
        OfferPreviewCard: domainOffersComponentsOfferPreviewCard,
        OfferStatusAlert: domainOffersComponentsOfferStatusAlert,
        OffersEmptyState: domainOffersComponentsOffersEmptyState,
        OffersTable: domainOffersComponentsOffersTable,
      },
      schemas: domainOffersSchemas,
      utils: domainOffersUtils,
    },
    onboarding: {
      Onboarding: domainOnboardingOnboarding,
      components: {
        ContactStep: domainOnboardingComponentsContactStep,
        OnboardingForm: domainOnboardingComponentsOnboardingForm,
        OrganizationStep: domainOnboardingComponentsOrganizationStep,
        ReviewStep: domainOnboardingComponentsReviewStep,
      },
      schemas: domainOnboardingSchemas,
      utils: domainOnboardingUtils,
    },
    results: {
      Results: domainResultsResults,
      components: {
        CampaignLeadsSection: domainResultsComponentsCampaignLeadsSection,
        CampaignPicker: domainResultsComponentsCampaignPicker,
        CampaignSummary: domainResultsComponentsCampaignSummary,
        ClicksByDayChart: domainResultsComponentsClicksByDayChart,
        ReportActionsTable: domainResultsComponentsReportActionsTable,
        ReportIndicators: domainResultsComponentsReportIndicators,
        ReportSlicesTable: domainResultsComponentsReportSlicesTable,
        ResultsEmptyState: domainResultsComponentsResultsEmptyState,
      },
      utils: domainResultsUtils,
    },
  },
  hooks: {
    usePostalCodeLookup: hooksUsePostalCodeLookup,
  },
  utils: {
    error: utilsError,
    errors: utilsErrors,
    image: utilsImage,
    schemas: utilsSchemas,
  },
};
